import * as yup from 'yup';
import commonValidators, { ICommonValidator } from './commonValidators';
import { Employee, FormGenerator } from '../api/clients';

interface IAircraftNumber extends ICommonValidator {}

interface IAirportValidator extends ICommonValidator {}

interface ICrewMemberValidator extends ICommonValidator {
  requiredIfRevenue?: boolean,
  optionalIfBlankGenerated?: boolean,
  requiredOnDependent?: { fieldName: string, value: any }
}

interface IFlightNumberValidator extends ICommonValidator {
  optionalIfBlankGenerated?: boolean,
}

const aircraftNumber = ({ required, step, label }: IAircraftNumber) => {
  const validator = commonValidators.nullableString({ step, required, label });
  return validator.min(3).max(6);
};

const airport = ({ required, step, label }: IAirportValidator) => {
  const validator = commonValidators.nullableString({ step, required, label });
  return validator.min(4).max(4);
};

const crewMember = ({
  requiredIfRevenue,
  optionalIfBlankGenerated,
  step,
  label,
  requiredOnDependent,
}: ICrewMemberValidator) => {
  const validator = commonValidators.nullableString({ label, step });
  if (requiredOnDependent) {
    return validator
      .when(requiredOnDependent.fieldName, {
        is: (field: any) => field === requiredOnDependent.value,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.optional(),
      });
  }

  return validator
    .when(['formGeneratedFrom', 'typeOfFlight'], {
      // eslint-disable-next-line max-len
      is: (formGeneratedFrom: FormGenerator, typeOfFlight: string) => (optionalIfBlankGenerated && formGeneratedFrom === FormGenerator.Blank)
        || (requiredIfRevenue && typeOfFlight !== 'Revenue (part 121)'),
      then: (schema) => schema.optional(),
      otherwise: (schema) => schema.required(),
    });
};

const flightNumber = ({ label, step, optionalIfBlankGenerated }: IFlightNumberValidator) => {
  const validator = commonValidators.nullableString({ label, step });

  return validator
    .when('formGeneratedFrom', {
      is: (formGeneratedFrom: FormGenerator) => formGeneratedFrom === FormGenerator.Blank && optionalIfBlankGenerated,
      then: (schema) => schema.optional(),
      otherwise: (schema) => schema.required(),
    });
};

const mainlinePartner = ({ label, step, optionalIfBlankGenerated }: IFlightNumberValidator) => {
  const validator = yup.string().label(label).meta({ step }).required();

  return validator
    .when('formGeneratedFrom', {
      is: (formGeneratedFrom: FormGenerator) => formGeneratedFrom === FormGenerator.Blank && optionalIfBlankGenerated,
      then: (schema) => schema.optional(),
      otherwise: (schema) => schema.required(),
    });
};
export default {
  aircraftNumber,
  airport,
  crewMember,
  flightNumber,
  mainlinePartner,
};
